// src/components/Layout.js
import React from 'react';
import BottomNavBar from './BottomNavBar';
import SideNavBar from './SideNavBar';

const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen">
      {/* Side Navigation for Tablet/Desktop */}
      <div className="hidden md:flex">
        <SideNavBar />
      </div>
      
      {/* Main Content Area */}
      <main className="flex-grow bg-slate-50">
        {children}
      </main>
      
      {/* Bottom Navigation for Mobile */}
      <BottomNavBar />
    </div>
  );
};

export default Layout;